module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-shop-banner-large-9bb80ca325292304f25eef0368832dc8.jpg";